<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>add</md-icon>
          </div>
          <h4 class="title">Create New Wingio Product</h4>
        </md-card-header>

        <md-card-content>
          <md-field>
            <label>Product Name</label>
            <md-input v-model="productDetail.name" />
          </md-field>

          <md-field>
            <label>Display Name</label>
            <md-input v-model="productDetail.displayName" />
          </md-field>

          <md-field>
            <label>Short Description</label>
            <md-textarea v-model="productDetail.shortDescription" rows="4" />
          </md-field>

          <md-field>
            <label>Price (GBP)</label>
            <md-input v-model.number="productDetail.price" type="number" min="0" step="0.01" />
          </md-field>

          <md-field>
            <label>Offer Price (GBP)</label>
            <md-input v-model.number="productDetail.offerPrice" type="number" min="0" step="0.01" />
          </md-field>

          <md-field>
            <label>Offer Price Text</label>
            <md-input v-model.number="productDetail.offerPriceText" type="text" />
          </md-field>
        
            <md-field>
              <label>GTIN</label>
              <md-input v-model.number="productDetail.gtin" type="text" />
            </md-field>
          
            <md-field>
                <label>Product Category</label>
                <md-select v-model="productDetail.productCategory">
                    <md-option value="Phones">Phones</md-option>
                    <md-option value="Tablets">Tablets</md-option>
                </md-select>
            </md-field>

            <div class="file-upload">
                <label for="mainImageUpload"><strong>Main Product Image</strong></label><br />
                <input id="mainImageUpload" type="file" @change="handleImageUpload" accept="image/*" />
            </div>


          <h4 class="title pt-4 pb-2"><b>Product Specifications</b></h4>
          <div v-for="(spec, index) in productDetail.productSpecifications" :key="index" class="spec-row">
            <md-field>
              <label>Key</label>
              <md-input v-model="spec.key" />
            </md-field>

            <md-field>
              <label>Value</label>
              <md-input v-model="spec.value" />
            </md-field>

            <md-button class="md-icon-button md-danger" @click="removeSpecification(index)">
              <md-icon>delete</md-icon>
            </md-button>
          </div>

          <div class="button-actions">
            <md-button class="md-raised md-primary" @click="addSpecification">
              Add Specification
            </md-button>
          </div>

          <div class="button-update">
            <md-button class="md-raised md-success" @click="createProduct" :disabled="isDisabled">
              Create Product <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
            </md-button>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import OrdersDataService from "../../services/SuperAdmin/Kids/OrdersDataService";

export default {
  data() {
    return {
      isDisabled: false,
      mainImageFile: null,
      productDetail: {
        name: "",
        displayName: "",
        shortDescription: "",
        longDescription: "",
        camera: "",
        memory: "",
        screen: "",
        battery: "",
        price: null,
        offerPrice: null,
        offerPriceTex: "",
        gtin: "",
        productType: "Onetime",
        productSpecifications: [],
        productCategory: "",
        mainImage: "",
      }
    };
  },
  methods: {
    handleImageUpload(event) {
        this.mainImageFile = event.target.files[0];
    },
    addSpecification() {
      this.productDetail.productSpecifications.push({ key: "", value: "" });
    },
    removeSpecification(index) {
      this.productDetail.productSpecifications.splice(index, 1);
    },
    async createProduct() {
        this.isDisabled = true;
        if (this.mainImageFile) {
            const formData = new FormData();
            formData.append("images[]", this.mainImageFile); // no productId

            const uploadRes = await OrdersDataService.uploadWingioProductImages(formData);
            const uploadedImage = uploadRes.data?.data?.[0];
            if (uploadedImage?.productImage) {
                this.productDetail.mainImage = uploadedImage.productImage;
            }
        }

      OrdersDataService.createProduct(this.productDetail)
        .then(() => {
          this.isDisabled = false;
          this.$toast.success("Product created successfully.");
          this.$router.push("/kid/wingio-products");
        })
        .catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    }
  }
};
</script>

<style scoped>
.spec-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.spec-row .md-field {
  flex: 1;
}

.spec-row .md-button {
  margin-top: 20px;
}

.button-actions {
  display: flex;
  gap: 10px;
}

.button-update {
  margin-top: 20px;
  text-align: center;
}

.file-upload {
  margin-bottom: 20px;
}

.file-upload label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
}

.file-upload input[type="file"] {
  display: inline-block;
}

</style>
